export default __webpack_public_path__ + "static/media/download_svg.2a0e2245.svg";